module.exports = __webpack_public_path__ + "static/media/about-marburg.26b782fb.mp4";